import React, { useEffect, useState,useRef} from "react"
import { useNavigate } from "react-router-dom";
import GetRequest from "../../../../service/GetRequest";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Button } from 'primereact/button';
import SalesChart from "../../../../components/DashboardComponents/SalesChart/SalesChart";
import { useMountEffect } from 'primereact/hooks';
import { Messages } from 'primereact/messages';
import '../../StoreDashboard/style.css'
import TileSelection from "../../../../components/Widgets/TileSelection/TileSelection";
// import BranchInfoStatiticsToolbar from "../../../../components/Widgets/Toolbars/BranchInfoStatiticsToolbar";
import CookieHandler from '../../../LandingPage/Authentication/CookieHandler'

const DashboardPage = ({setActivePath}) => {
  const navigate = useNavigate();
  const userId = CookieHandler.getCookie("userid");
  const [open, setOpen] = useState(false);

    useEffect(() => {
        setActivePath("Dashboard"); 
        GetRequest("v1/store-management-service/check/store/deployed",true)
                      .then(response=>{
                          if(response === undefined){
                                  console.log("No store found for this user")
                              } else {
                                if (response === false){
                                  console.log("the deployed response is ",response)
                                  handleClickOpen();
                                }
                              }      
                          
                      })   
       
      }, [setActivePath, navigate,userId]);

      const handleClickOpen = () => {
        setOpen(true);
    };
    
    const handleClose = () => {
        setOpen(false);
    };

    const msgs = useRef(null);

    useEffect(() => {
        setActivePath("Manage Inventory");
      }, [setActivePath]);

      useMountEffect(() => {
        if (msgs.current) {
            msgs.current.clear();
            msgs.current.show([
                { sticky: true, severity: 'warn', summary: 'Warning', detail: 'Your free trail is about to end, please upgrade to prevent losing data!' },
            ]);
        }
    });

    

  return (
    <div className="outlet-container">
            <Messages ref={msgs}/>
       <Dialog
                            open={open}
                            onClose={handleClose}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            fullWidth="lg"
                        >
                            <DialogTitle id="alert-dialog-title">Please complete the Store creation settings</DialogTitle>

                            <DialogContent>
                                  <DialogContentText id="alert-dialog-description">
                                      You haven't deployed your store yet, please complete the intialisation settings to continue.
                                  </DialogContentText>
                               </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose} label="Cancel" />
                                  
                                    <Button 
                                      onClick={() => {
                                          navigate("/store/complete/profile");
                                          handleClose();
                                      }} 
                                      autoFocus  label="Continue to Store Registration"/>
                  

                                </DialogActions>
                        </Dialog>
        
          <div className="dashboard-main-area-container">
            <TileSelection/>
          <div className="user-graph-container">
            <SalesChart/>
          </div>
         
          </div>
        
        
        <div className="flex-container">
          <div className="dashbaord-sub-footer-section"></div>
          <div className="dashbaord-sub-footer-section"></div>
          <div className="dashbaord-sub-footer-section"></div>
        </div>

      
    </div>
  )
}

export default DashboardPage
